import { useMemo } from 'react';
import { DataAttributeList, FloatingBox, formatNumber } from 'ui';
import {
  CheckBoxOutlined,
  ClassOutlined,
  LocalShippingOutlined,
  LocationOnOutlined,
  MapOutlined,
  ScaleOutlined,
  WarehouseOutlined,
} from 'ui/icons';

export const QualityReportSummary = ({
  originCountry,
  material,
  grade,
  availableTonnage,
  estimatedDeliveryDate,
  tonnesPerLoad,
  deliveryLocation,
}: {
  originCountry?: string;
  material: string;
  grade: string;
  availableTonnage?: string;
  estimatedDeliveryDate?: string;
  tonnesPerLoad?: string;
  deliveryLocation?: string;
}) => {
  const details = useMemo(() => {
    const qualityReportDetails = [
      {
        fullRow: true,
        icon: ClassOutlined,
        subtitle: material,
        title: 'Material',
      },
      {
        fullRow: false,
        icon: CheckBoxOutlined,
        subtitle: grade,
        title: 'Material Grade',
      },
    ];

    if (originCountry) {
      qualityReportDetails.push({
        fullRow: false,
        icon: MapOutlined,
        subtitle: originCountry,
        title: 'Location',
      });
    }

    if (availableTonnage) {
      qualityReportDetails.push({
        fullRow: false,
        icon: WarehouseOutlined,
        subtitle: formatNumber(availableTonnage, {
          style: 'ton',
        }),
        title: 'Available Material',
      });
    }

    if (tonnesPerLoad) {
      qualityReportDetails.push({
        fullRow: false,
        icon: ScaleOutlined,
        subtitle: formatNumber(tonnesPerLoad, {
          style: 'ton',
        }),
        title: 'Tonnes per load',
      });
    }

    if (estimatedDeliveryDate) {
      qualityReportDetails.push({
        fullRow: false,
        icon: LocalShippingOutlined,
        subtitle: estimatedDeliveryDate,
        title: 'Estimated Delivery',
      });

      if (deliveryLocation) {
        qualityReportDetails.push({
          fullRow: false,
          icon: LocationOnOutlined,
          subtitle: deliveryLocation,
          title: 'Delivery Location',
        });
      }
    }

    return qualityReportDetails;
  }, [material, grade, originCountry, availableTonnage, tonnesPerLoad, estimatedDeliveryDate, deliveryLocation]);

  return (
    <FloatingBox>
      <DataAttributeList dataPoints={details} />
    </FloatingBox>
  );
};
